<template>
  <div>
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <v-dialog v-model="dialogElemento" max-width="50%">
      <v-card>
        <v-card-title>
          Agregar {{ label }}
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="elementoEditedItem.nombre"
                outlined
                :label="label"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text
            color="green"
            class="white--text"
            @click="restablecerElemento"
            :loading="savingElemento"
          >
            Cancelar
          </v-btn>

          <v-btn
            text
            color="red"
            class="white--text"
            @click="guardarElemento"
            :loading="savingElemento"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Con botón de + -->
    <v-autocomplete
      v-if="!hideAdd"
      :key="autoKey"
      v-model="localValue"
      :items="elementos"
      :item-text="itemText"
      :item-value="itemValue"
      outlined
      :label="label"
      :loading="loadingElemento"
      :disabled="loadingElemento || disabled"
      append-outer-icon="mdi-plus"
      @click:append-outer="addElemento"
      @change="updateValue"
      dense
      hide-details
      :filter="filterAutocomplete"
    >
      <template v-slot:input="slotProps">
        <input
          v-bind="slotProps.attrs"
          :value="slotProps.attrs.value"
          @input="slotProps.listeners.input"
          @blur="slotProps.listeners.blur"
          :name="'fake-name-' + _uid"
          autocomplete="new-password"
          autocapitalize="off"
          spellcheck="false"
        />
      </template>
    </v-autocomplete>

    <!-- Sin botón de + -->
    <v-autocomplete
      v-else
      :key="autoKey"
      v-model="localValue"
      :items="elementos"
      :item-text="itemText"
      :item-value="itemValue"
      outlined
      :label="label"
      :loading="loadingElemento"
      :disabled="loadingElemento || disabled"
      @change="updateValue"
      dense
      hide-details
      :filter="filterAutocomplete"
    >
      <template v-slot:input="slotProps">
        <input
          v-bind="slotProps.attrs"
          :value="slotProps.attrs.value"
          @input="slotProps.listeners.input"
          @blur="slotProps.listeners.blur"
          :name="'fake-name-' + _uid"
          autocomplete="new-password"
          autocapitalize="off"
          spellcheck="false"
        />
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import VAlertDialog from '@/components/VAlertDialog.vue'
import axios from "axios"

export default {
  name: "VAutocompleteAdd",
  components: { VAlertDialog },
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: ""
    },
    itemValue: {
      type: String,
      default: ""
    },
    itemText: {
      type: String,
      default: "nombre"
    },
    urlSave: {
      type: String,
      default: ""
    },
    urlGet: {
      type: String,
      default: ""
    },
    hideAdd: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    localValue: null,
    elementos: [],
    loadingElemento: false,
    dialogElemento: false,
    elementoEditedItem: {
      nombre: null
    },
    defaultElementoEditedItem: {
      nombre: null
    },
    savingElemento: false,

    // =========================
    // FIX: valor antes de cargar items
    // =========================
    pendingValue: null,
    autoKey: 0,
  }),
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        // Si todavía está cargando o aún no hay items, lo guardamos pendiente
        if (this.loadingElemento || !this.elementos || this.elementos.length === 0) {
          this.pendingValue = newValue;
          this.localValue = newValue; // mantiene el id, aunque aún no pinte el texto
          return;
        }

        // Ya hay items, aplicamos normal
        this.localValue = newValue;
        this.refreshAutocomplete();
      }
    }
  },
  mounted() {
    this.getElementos();
  },
  methods: {
    refreshAutocomplete() {
      // Fuerza reconstrucción para que Vuetify resuelva item-text con el item-value
      this.autoKey++;

      // Truco extra: re-asignar para disparar recalculo interno
      this.$nextTick(() => {
        const v = this.localValue;
        this.localValue = null;
        this.$nextTick(() => {
          this.localValue = v;
        });
      });
    },

    restablecerElemento() {
      this.elementoEditedItem = Object.assign({}, this.defaultElementoEditedItem);
      this.dialogElemento = false;
    },

    guardarElemento() {
      if (this.elementoEditedItem.nombre == null) {
        this.$refs.alert.setMessage('', `Debe de indicar un nombre`);
        this.$refs.alert.open();
        return;
      }

      // OJO: aquí tenías un bug: this.elementoEditedItem.length -> debe ser this.elementoEditedItem.nombre.length
      if (this.elementoEditedItem.nombre.length <= 0 || this.elementoEditedItem.nombre.length > 255) {
        this.$refs.alert.setMessage('', `El nombre debe de tener entre 1 y 256 caracteres.`);
        this.$refs.alert.open();
        return;
      }

      this.savingElemento = true;
      axios
        .post(this.urlSave, {
          nombre: this.elementoEditedItem.nombre
        })
        .then(response => {
          this.getElementos();
          this.localValue = response.data;
          this.updateValue();
          this.restablecerElemento();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.savingElemento = false;
        })
    },

    addElemento() {
      this.elementoEditedItem = Object.assign({}, this.defaultElementoEditedItem);
      this.dialogElemento = true;
    },

    getElementos() {
      this.loadingElemento = true;
      axios
        .get(this.urlGet)
        .then(response => {
          this.elementos = response.data;

          // Si llegó value antes de cargar items, lo aplicamos aquí
          if (this.pendingValue !== null && typeof this.pendingValue !== 'undefined') {
            this.localValue = this.pendingValue;
            this.pendingValue = null;
          }

          this.refreshAutocomplete();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingElemento = false;
        })
    },

    updateValue() {
      this.$emit('input', this.localValue);
    },

    normalize(str = '') {
      return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    },

    filterAutocomplete(item, queryText, itemText) {
      const text = this.normalize(itemText);
      const query = this.normalize(queryText);
      return text.startsWith(query);
    },
  }
}
</script>
